import React, { useRef, useEffect } from 'react';
import { InformationOutline } from 'pcln-icons';
import { useOtpContext } from '../../context/OtpContext';
import { Box, Flex, GenericBanner, Text } from 'pcln-design-system';
const FindMyTripsErrors = () => {
  const {
    otpRequestErrorMsg
  } = useOtpContext();
  const messageEndRef = useRef(null);
  useEffect(() => {
    var _a;
    (_a = messageEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
      behavior: 'smooth'
    });
  }, [otpRequestErrorMsg]);
  return React.createElement(React.Fragment, null, otpRequestErrorMsg ? React.createElement(Flex, {
    flexDirection: 'column',
    justifyContent: 'center',
    "data-testid": 'try-again'
  }, React.createElement(GenericBanner, {
    mx: 3,
    my: 3,
    p: 2,
    borderRadius: 'lg',
    color: 'background.light',
    iconLeft: React.createElement(InformationOutline, {
      color: 'warning.base',
      "data-testid": 'information-outline-icon'
    }),
    text: React.createElement(Text.span, {
      textStyle: 'subheading6'
    }, otpRequestErrorMsg, React.createElement(Text.span, {
      textStyle: 'subheading6'
    }, "Please try again."))
  })) : null, React.createElement(Box, {
    ref: messageEndRef
  }));
};
export default FindMyTripsErrors;